import { useEffect, useState } from 'react'
import Header from '../components/Header'
import { Link } from 'react-router-dom'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import Menu from '../components/Menu';
import { useAllContext } from '../context/AllContext';
import { useTranslation } from 'react-i18next';
import useGoogleAuthRedirect from '../hooks/useGoogleAuthRedirect';

const Home = () => {
    const { getUpcomingEvent, upcomingEvent,
        getPastEvent, pastEvent,
        getPastCitiesWithBattles, pastCitiesWithBattles,
        getCityEventDetails, cityEventDetails
    } = useAllContext()

    const { t, i18n } = useTranslation()
    useGoogleAuthRedirect()

    const [activeCity, setActiveCity] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getUpcomingEvent()
        getPastEvent()
        getPastCitiesWithBattles()
    }, [])

    const fetchApiData = async (cityId) => {
        try {
            setLoading(true);

            await getCityEventDetails(cityId);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!pastCitiesWithBattles || pastCitiesWithBattles.length === 0) return;

        fetchApiData(pastCitiesWithBattles?.[0]?.city_id);

    }, [pastCitiesWithBattles]);

    return (
        <>
            <div className='main-content'>
                <Header page={"home"} title={`${t('Welcome to LIMITS')}!`} backpage={'/'} />

                <div className='swiper-overflow overflow-hidden'>
                    <div className='padding2 pb-1'>
                        <div className='container'>
                            <div className='d-flex align-items-center mb-2'>
                                <div className='w-100 me-2'>
                                    <p className='mb-0 fw-semibold text-white'>{t('Swipe Through Limits Events')}</p>
                                </div>
                                <div className='text-end'>
                                    <h6 className='mb-0 text-nowrap'><Link to='' className='link'>{t('See All')}</Link></h6>
                                </div>
                            </div>

                            <div className='swiper1'>
                                <Swiper
                                    slidesPerView={1.5}
                                    spaceBetween={0}
                                    centeredSlides={true}
                                    loop={false}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    breakpoints={{
                                        575: {
                                            slidesPerView: 1.5
                                        },
                                        768: {
                                            slidesPerView: 1.75
                                        },
                                        1200: {
                                            slidesPerView: 1.75
                                        }
                                    }}
                                    className="mySwiper overflow-visible"
                                >

                                    {
                                        upcomingEvent && upcomingEvent.map((items, ind) => {
                                            return <SwiperSlide key={ind}>
                                                <div className='slider-box'>
                                                    <Link to={`/event-details/${items._id}`}><img src={`${process.env.REACT_APP_IMAGES_URL}/${items.images[0]}`} crossOrigin="anonymous" className="img-fluid img1" alt="" /></Link>
                                                </div>
                                            </SwiperSlide>
                                        })
                                    }

                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='padding2 pt-0'>
                    <div className='container'>
                        <div className='d-flex align-items-center mb-3'>
                            <div className='w-100 me-2'>
                                <p className='mb-0 fw-semibold text-white'>{t('See Previous Event Winners')}</p>
                            </div>
                            <div className='text-end'>
                                <h6 className='mb-0 text-nowrap'><Link to='' className='link'>{t('See All')}</Link></h6>
                            </div>
                        </div>

                        <div className='mb-3'>
                            <nav className="nav nav1 d-flex scrollbar flex-nowrap pb-1">
                                {pastCitiesWithBattles?.map((city, index) => (
                                    <Link
                                        key={city.city_id}
                                        to="#"
                                        onClick={() => {
                                            setActiveCity(index);
                                            fetchApiData(city.city_id);
                                        }}
                                        className={`nav-link ${activeCity === index ? "active" : ""}`}
                                    >
                                        {city.cityName}
                                    </Link>
                                ))}
                            </nav>
                        </div>

                        <div className='row gy-3 gx-3'>
                            {
                                loading ? (
                                    <div className="col-12 text-center py-5">
                                        <h5 className="text-white-50">Loading...</h5>
                                    </div>
                                ) : cityEventDetails && cityEventDetails.length > 0 ? (
                                    // ✅ Data State
                                    cityEventDetails.map((items) => {
                                        return (
                                            <div className='col-xl-4 col-md-6 col-12' key={items._id}>
                                                <Link to={`/event-details/${items._id}`}>
                                                    <div className='card card1 h-100'>
                                                        <div className='card-body'>

                                                            <h6 className='mb-1 text-white text-center'>
                                                                {i18n.language === 'en' ? items.title_eng : items.title_jap}
                                                            </h6>

                                                            <p className='fs-12 text-center mb-2'>
                                                                {items?.date_times?.[0]?.dates
                                                                    ? new Date(items.date_times[0].dates).toLocaleDateString()
                                                                    : "-"}
                                                            </p>

                                                            {
                                                               items.battles .length > 0 ? (
                                                                    <div className='row gx-2 text-center align-items-center'>

                                                                        {/* Player 1 */}
                                                                        <div className='col-4'>
                                                                            <div className={`player1 ${items?.battles?.[0]?.winner === "battle1" ? "winner" : ""}`}>
                                                                                {
                                                                                    items?.battles?.[0]?.battle1?.profileImage ? (
                                                                                        items.battles[0].battle1.profileImage.includes('google') ?
                                                                                            <img
                                                                                                src={items.battles[0].battle1.profileImage}
                                                                                                className="img-fluid img1"
                                                                                                alt="user"
                                                                                            />
                                                                                            :
                                                                                            <img
                                                                                                src={`${process.env.REACT_APP_IMAGES_URL}/${items.battles[0].battle1.profileImage}`}
                                                                                                crossOrigin="anonymous"
                                                                                                className="img-fluid img1"
                                                                                                alt="user"
                                                                                            />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={require('../assets/images/user-img.png')}
                                                                                            className="img-fluid img1"
                                                                                            alt="default-user"
                                                                                        />
                                                                                    )
                                                                                }

                                                                                <h6 className='mb-0 text-white'>
                                                                                    {items?.battles?.[0]?.battle1?.username || "-"}
                                                                                </h6>
                                                                            </div>
                                                                        </div>

                                                                        {/* Score */}
                                                                        <div className='col-4'>
                                                                            <h5 className='mb-1 text-main fw-semibold'>
                                                                                {items?.battles?.[0].winner === "battle1"
                                                                                ? items?.battles?.[0]?.battle1?.username
                                                                                : items?.battles?.[0].winner === "battle2"
                                                                                    ? items?.battles?.[0]?.battle2?.username
                                                                                    : "-"}
                                                                            </h5>
                                                                            <p className='mb-0 text-white'>Winner</p>
                                                                            {/* <h2 className='mb-1 text-white fw-semibold'>1st : 2nd</h2> */}
                                                                        </div>

                                                                        {/* Player 2 */}
                                                                        <div className='col-4'>
                                                                            <div className={`player1 ${items?.battles?.[0]?.winner === "battle2" ? "winner" : ""}`}>
                                                                                {
                                                                                    items?.battles?.[0]?.battle2?.profileImage ? (
                                                                                        items.battles[0].battle2.profileImage.includes('google') ?
                                                                                            <img
                                                                                                src={items.battles[0].battle2.profileImage}
                                                                                                className="img-fluid img1"
                                                                                                alt="user"
                                                                                            />
                                                                                            :
                                                                                            <img
                                                                                                src={`${process.env.REACT_APP_IMAGES_URL}/${items.battles[0].battle2.profileImage}`}
                                                                                                crossOrigin="anonymous"
                                                                                                className="img-fluid img1"
                                                                                                alt="user"
                                                                                            />
                                                                                    ) : (
                                                                                        <img
                                                                                            src={require('../assets/images/user-img.png')}
                                                                                            className="img-fluid img1"
                                                                                            alt="default-user"
                                                                                        />
                                                                                    )
                                                                                }

                                                                                <h6 className='mb-0 text-white'>
                                                                                    {items?.battles?.[0]?.battle2?.username || "-"}
                                                                                </h6>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                               ) : (
                                                                <div className='py-4'>
                                                                    <p className="text-center mb-0">{items.message}</p>
                                                                </div>
                                                               )
                                                            }

                                                            
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <h5 className="text-white-50">No Data Found</h5>
                                    </div>
                                )
                            }


                        </div>

                        {/* <div className='row gy-3 gx-3'>
                            {
                                loading ? (
                                    <div className="col-12 text-center py-5">
                                        <h5 className="text-white-50">Loading...</h5>
                                    </div>
                                ) : cityEventDetails && cityEventDetails.length > 0 ? (

                                    cityEventDetails.map((items) => {

                                        return items?.battles?.map((battle, index) => (

                                            <div className='col-xl-4 col-md-6 col-12' key={items._id + index}>
                                                <Link to={`/event-details/${items._id}`}>
                                                    <div className='card card1'>
                                                        <div className='card-body'>

                                                            <h6 className='mb-1 text-white text-center'>
                                                                {i18n.language === 'en' ? items.title_eng : items.title_jap}
                                                            </h6>

                                                            <p className='fs-12 text-center mb-2'>
                                                                {items?.date_times?.[0]?.dates
                                                                    ? new Date(items.date_times[0].dates).toLocaleDateString()
                                                                    : "-"}
                                                            </p>

                                                            <h6 className='text-center text-main mb-3'>
                                                                {battle.battle_name}
                                                            </h6>

                                                            <div className='row gx-2 text-center align-items-center'>

                                                                <div className='col-4'>
                                                                    <div className='player1'>
                                                                        <img
                                                                            src={
                                                                                battle?.battle1?.profileImage?.includes('google')
                                                                                    ? battle.battle1.profileImage
                                                                                    : `${process.env.REACT_APP_IMAGES_URL}/${battle?.battle1?.profileImage}`
                                                                            }
                                                                            className="img-fluid img1"
                                                                            alt="user"
                                                                        />
                                                                        <h6 className='mb-0 text-white'>
                                                                            {battle?.battle1?.username || "-"}
                                                                        </h6>
                                                                    </div>
                                                                </div>

                                                                <div className='col-4'>
                                                                    <h6 className='mb-1 text-main'>Winner</h6>

                                                                    <p className='mb-0 text-white'>
                                                                        {
                                                                            battle?.winner === "battle1"
                                                                                ? battle?.battle1?.username
                                                                                : battle?.winner === "battle2"
                                                                                    ? battle?.battle2?.username
                                                                                    : "TBD"
                                                                        }
                                                                    </p>
                                                                </div>

                                                                <div className='col-4'>
                                                                    <div className='player1'>
                                                                        <img
                                                                            src={
                                                                                battle?.battle2?.profileImage?.includes('google')
                                                                                    ? battle.battle2.profileImage
                                                                                    : `${process.env.REACT_APP_IMAGES_URL}/${battle?.battle2?.profileImage}`
                                                                            }
                                                                            className="img-fluid img1"
                                                                            alt="user"
                                                                        />
                                                                        <h6 className='mb-0 text-white'>
                                                                            {battle?.battle2?.username || "-"}
                                                                        </h6>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>

                                        ))

                                    })

                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <h5 className="text-white-50">No Data Found</h5>
                                    </div>
                                )
                            }
                        </div> */}
                    </div>
                </div>

                <Menu />
            </div>
        </>
    )
}

export default Home
